import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CONTENT = {
  hero_naslov: "Vrhunski lesni materiali in natančen razrez na enem mestu.",
  hero_podnaslov: "Profesionalne rešitve za mizarje, arhitekte in domače mojstre. Izberite iverale, naročite razrez po meri ter opremite pohištvo z vrhunskim okovjem.",
  hero_slika_1: "https://images.unsplash.com/photo-1585773818428-b50bebdc2344?auto=format&fit=crop&w=1200&q=80",
  hero_slika_2: "https://images.unsplash.com/photo-1702200047649-ddefe9d4faa9?auto=format&fit=crop&w=800&q=80",
  hero_slika_3: "https://images.unsplash.com/photo-1531824475211-72594993ce2a?auto=format&fit=crop&w=800&q=80",
  onas_naslov: "Od hloda do gotovega pohištva",
  onas_besedilo: "HobbyCenter je specializirana trgovina z lesnimi materiali, kuhinjskimi elementi in pohištvenim okovjem. Z lastno CNC formatno žago in robilnim strojem nudimo razrez in robljenje po meri — natančno, hitro in po ugodni ceni.",
  onas_slika: "https://images.unsplash.com/photo-1560846389-956694677531?auto=format&fit=crop&w=1000&q=80",
  kat_iverali_opis: "Oplemeniteni iverali, MDF, OSB in vezane plošče v vseh debelinah.",
  kat_iverali_slika: "https://images.unsplash.com/photo-1564512533667-015a90133f04?auto=format&fit=crop&w=800&q=80",
  kat_delovne_plosce_opis: "Kuhinjski pulti, odporni na vročino, vlago in obrabo.",
  kat_delovne_plosce_slika: "https://images.unsplash.com/photo-1714860534425-7ce04e013dec?auto=format&fit=crop&w=800&q=80",
  kat_kuhinjski_elementi_opis: "Modularni spodnji in zgornji elementi ter predalniki.",
  kat_kuhinjski_elementi_slika: "https://images.unsplash.com/photo-1722605090433-41d1183a792d?auto=format&fit=crop&w=800&q=80",
  kat_pohistveno_okovje_opis: "Ročaji, tečaji, vodila in nogice priznanih proizvajalcev.",
  kat_pohistveno_okovje_slika: "https://images.unsplash.com/photo-1683101513533-3a90a4602403?auto=format&fit=crop&w=800&q=80",
  kat_razrez_opis: "Natančen razrez po meri in robna obdelava z ABS trakom.",
  kat_razrez_slika: "https://images.unsplash.com/photo-1560846389-956694677531?auto=format&fit=crop&w=800&q=80",
  pogoji_text: "",
  piskotki_text: "",
  pravna_text: "",
};

let cache = null;

export function invalidateContentCache() {
  cache = null;
}

export function useContent() {
  const [content, setContent] = useState(cache || DEFAULT_CONTENT);
  useEffect(() => {
    if (cache) return;
    api.get("/content")
      .then((r) => {
        cache = { ...DEFAULT_CONTENT, ...r.data };
        setContent(cache);
      })
      .catch(() => {});
  }, []);
  return content;
}
